import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fillNonNullValues, THUNK_STATUS } from "@duosoftbg/nacid-components";
import { baseEndpointPaths, getApplicationById } from "../../../../services/serviceCalls";
import { initialSeRecognitionApplication } from "../../../../init/seRecognitionInitialValues";

export const fetchSeRecognitionForm = createAsyncThunk("seRecognitionForm/fetchStatus", async (id: number | string) => {
  const response = await getApplicationById(baseEndpointPaths.seRecognition, id)();
  return response;
});

const seRecognitionFormSlice = createSlice({
  name: "SERecognitionStoreSlice",
  initialState: initialSeRecognitionApplication,
  reducers: {
    setRequestIdentifier: (state, action) => {
      state.id = action.payload;
    },
    completeApplicantStep: (state, action) => {
      state.applicantDetails = action.payload;
      state.steps[0].completed = true;
    },
    completeEducationStep: (state, action) => {
      state.educationDetails = action.payload;
      state.steps[1].completed = true;
    },
    completeDocumentStep: (state, action) => {
      state.documentDetails = action.payload;
      state.steps[2].completed = true;
    },
    resetSeRecognitionRequest: () => initialSeRecognitionApplication,
    setStepApplicantEdited: (state, action) => {
      state.steps[0].isEdited = action.payload;
    },
    setStepEducationEdited: (state, action) => {
      state.steps[1].isEdited = action.payload;
    },
    setStepDocumentsEdited: (state, action) => {
      state.steps[2].isEdited = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSeRecognitionForm.fulfilled, (state, action) => {
      state.dataStateStatus = THUNK_STATUS.FULFILLED;

      const updatedValues = { ...initialSeRecognitionApplication };
      fillNonNullValues(action.payload.data, updatedValues);

      state.id = updatedValues.id;
      state.applicantDetails = updatedValues.applicantDetails;
      state.educationDetails = updatedValues.educationDetails;
      state.documentDetails = updatedValues.documentDetails;
      state.submittedOrFinalized = updatedValues.submittedOrFinalized;

      state.steps[0].completed = true;
      if (
        state.educationDetails.schoolCountry &&
        state.educationDetails.schoolCountry.id &&
        state.educationDetails.schoolCountry.id !== ""
      ) {
        state.steps[1].completed = true;
      } else {
        state.steps[1].completed = false;
      }
      if (state.documentDetails.attachments.length > 0) {
        state.steps[2].completed = true;
      } else {
        state.steps[2].completed = false;
      }
    });
    builder.addCase(fetchSeRecognitionForm.pending, (state, action) => {
      state.dataStateStatus = THUNK_STATUS.PENDING;
    });
    builder.addCase(fetchSeRecognitionForm.rejected, (state, action) => {
      state.dataStateStatus = THUNK_STATUS.REJECTED;
    });
  },
});

export const {
  setRequestIdentifier,
  completeApplicantStep,
  completeDocumentStep,
  resetSeRecognitionRequest,
  setStepApplicantEdited,
  setStepDocumentsEdited,
  completeEducationStep,
  setStepEducationEdited,
} = seRecognitionFormSlice.actions;
export default seRecognitionFormSlice.reducer;
